<template>
<div style="margin: 0 30px;padding-bottom: 15px">
  <el-row>
    <el-col :span="12"><div class="line-info"><span>房间：</span></div></el-col>
    <el-col :span="12"><div class="line-info"><span>状态：</span></div></el-col>
    <el-col :span="12"><div class="line-info"><span>入住开始时间：</span></div></el-col>
    <el-col :span="12"><div class="line-info"><span>入住结束时间：</span></div></el-col>
<!--    <el-col :span="12"><div class="line-info"><span>押金：</span></div></el-col>-->
<!--    <el-col :span="12"><div class="line-info"><span>金额（元）：</span></div></el-col>-->
  </el-row>
</div>
</template>

<script>
export default {
  name: 'putUp'
}
</script>

<style scoped>
.line-info{
  height: 30px;
  font-size: 16px;
  color: #1a1a1a;
}
.line-info span{
  font-weight: 550;
}
</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/components/putUp.vue